import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'
import { connect } from 'react-redux'

import {
	createFiles,
	getFiles,
	getStorageQuota,
	openModal
} from 'state/actions'

import {
	getCurrentAccount,
	getCurrentUser,
	isCurrentUserGuest,
	getAccountProjects
} from 'state/selectors'

import SmoothCollapse from 'react-smooth-collapse'

import { forIn } from 'lodash'
import copy from 'fast-copy'
import { cloneDeep } from 'lodash'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import { 
	getFileDisplayData,
	getTotalAvailableStorage
} from 'utils'

import InputStandard from 'components/input/standard'

class ModalUpload extends Component {
	constructor(props) {
		super(props)

		const {
			data,
			currentProjectId
		} = this.props

		let fileData = data.file ? data.file : null

		if (data.chat) {
			this.isUploadingToChat = true
		} else {
			this.isUploadingToChat = false
		}

		this.state = {
			isLoading: false,
			account: null,
			user: null,
			project_id: null,
			didFindDupe: false,
			uploadProgress: 0,
			versions: this.generateVersionData(fileData),
			selectedVersionIndex: 0,
			hasCheckedQuota: false,
			isOverQuota: false,
			validateResponsePinned: false,
		}

		if (data.file) {
			this.forceNewVersion = true
		} else {
			this.forceNewVersion = false
		}

		if (!data.chat && currentProjectId) {
			this.selectProject(currentProjectId)
		}
	}

	componentWillMount = _ => {
		const {
			accountData,
			getStorageQuota,
			openModal
		} = this.props

		// We're exempt.
		if(accountData && accountData.id !== 1){
			const totalAvailableMb = (getTotalAvailableStorage(accountData) * 1000)
			
			getStorageQuota(accountData.id, totalSizeInMb => {
				const isOverQuota = (totalSizeInMb >= totalAvailableMb)

				if(isOverQuota){
					openModal('pricing','pricing', {
						feature: 'files'
					})
				}

				this.setState({
					hasCheckedQuota: true,
					validateResponsePinned: isOverQuota,
					isOverQuota
				})
			})
		}
	}

	selectProject = id => {
		this.setState({
			isLoadingFiles: true
		})

		this.props.getFiles(id, _ => {
			this.setState({
				isLoadingFiles: false
			})
		})
	}

	generateVersionData = (file = null) => {
		const {
			data,
			currentProjectId
		} = this.props

		let versions = data.versions ? cloneDeep(data.versions) : cloneDeep(data.version)

		let versionData = []

		if (versions) {
			versions.forEach(version => {
				// if you're uploading a new 'version', they should all have the same 'file'
				let versionFile = file

				let dupeFileIfAny = this.dupeFileIfAny(version)

				if (!versionFile) {
					// if not, does this specific version look like it has any dupes?
					let tempFile = dupeFileIfAny

					if (tempFile) {
						versionFile = tempFile
					}
				}

				if (version) {
					let projectId = currentProjectId

					if (this.isUploadingToChat) {
						// search all the files we can to find dupes.
						if (dupeFileIfAny) {
							projectId = dupeFileIfAny.project_id
						} else {
							projectId = null
						}
					}

					versionData.push({
						...version,
						title: this.createNameFromFilename(version.object.name),
						is_new: versionFile ? 0 : 1,
						forceNewVersion: !!file,
						file_id: versionFile ? versionFile.id : null,
						dupe: dupeFileIfAny,
						project_id: projectId
					})
				}
			})
		}

		return versionData
	}

	assignFileIdToVersions = id => {
		let allVersions = copy(this.state.versions)

		allVersions.forEach(version => {
			version.file_id = id,
				version.is_new = 0
		})

		this.setState({
			versions: allVersions
		})
	}

	selectVersion = index => {
		this.setState({
			selectedVersionIndex: index
		})
	}

	getCurrentVersion = (version = null) => {
		const {
			versions,
			selectedVersionIndex
		} = this.state

		if (!version) {
			return versions[selectedVersionIndex]
		} else {
			return versions.find(loopedVersion => {
				return loopedVersion.id === version.id
			})
		}
	}

	createNameFromFilename = filename => {
		let newName

		newName = filename.replace(/_/g, ' ')
		newName = newName.replace(/-/g, ' ')
		newName = newName.replace(/\.[^/.]+$/, "")

		return newName
	}

	getPreviewData = version => {
		switch (version.object.type) {
			case 'image/png':
			case 'image/jpeg':
			case 'image/gif':
			case 'image/svg+xml':
				return (<img src={version.previewUrl} />)
		}

		return (
			<Icon name={getFileDisplayData(version.object.name).icon} />
		)
	}

	dupeFileIfAny = version => {
		if (!version || !version.object) {
			return false
		}

		const {
			allFiles,
			allVersions,
			currentProject
		} = this.props

		let dupe = null
		const filename = version.object.name

		if(!currentProject){
			return false
		}

		if (allFiles) {
			forIn(allVersions, loopedVersion => {
				if (!dupe && loopedVersion.filename == filename) {
					const tempDupe = allFiles[loopedVersion.file_id]

					if (!tempDupe || tempDupe.deleted_at || !tempDupe.project_id) {
						return
					}

					if (tempDupe.project_id == currentProject.id || this.isUploadingToChat) {
						dupe = tempDupe
					}
				}
			})
		}

		if (!dupe) {
			return false
		} else {
			return dupe
		}
	}


	componentDidMount() {
		this.setState({
			...this.state,
			account: this.props.currentAccount,
			user: this.props.userData
		})

		setTimeout(_ => {
			this.refs.titleInputRef.inputRef.focus()
		}, 1)
	}

	handleChange = (value, key) => {
		let tempState = {
			...this.state,
		}

		// get the relevant files if you've changed project. also clear selected file
		if (key == 'project_id') {
			if (value) {
				this.props.getFiles(value)
			}

			let latestVersion = tempState.versions[this.state.selectedVersionIndex]

			if (latestVersion.file_id !== value) {
				tempState.versions[this.state.selectedVersionIndex].file_id = null
				tempState.versions[this.state.selectedVersionIndex].is_new = true
			}
		}

		tempState.versions[this.state.selectedVersionIndex][key] = value

		this.setState(tempState)
	}

	handleSubmit = _ => {
		const {
			isLoading,
			data,
			handleError,
			setLoading,
			currentProjectId,
			currentProject,
			userData,
			createFiles,
			closeCallback
		} = this.props

		const {
			versions
		} = this.state

		if(isLoading) {
			return
		}

		let chat = data.chat ? data.chat : null

		let firstExistingVersionWithoutFile = null
		let firstVersionWithoutName = null

		versions.forEach(version => {
			if (!version.is_new && !version.file_id && !firstExistingVersionWithoutFile) {
				firstExistingVersionWithoutFile = version
			} else if (!firstVersionWithoutName && !version.title) {
				version.title = version.object.name
			}
		})

		if (firstExistingVersionWithoutFile) {
			handleError('Please select an existing file for "' + firstExistingVersionWithoutFile.title + '"')
			return
		}

		setLoading(true)

		// add uploaded to task to version(s)
		const uploaded_to_task = !!data.uploaded_to_task
		const file_folder_id = data.file_folder_id ? data.file_folder_id : null

		// add project ID to version(s)
		let project_id = null

		if (currentProjectId && !this.isUploadingToChat) {
			project_id = currentProject.id
		} else {
			if (!data.chat) {
				handleError("An unknown error has occurred!")
				return
			}
		}

		// create request data
		const requestData = []

		versions.forEach(version => {
			const versionObject = {
				...version,
				title: version.title ? version.title : version.object.name,
				user: userData,
				task: data.task,
				uploaded_to_task,
				file_folder_id,
				project_id: version.project_id ? version.project_id : project_id,
				task_id: data.task ? data.task.id : null,
				chat_id: chat ? chat.id : null
			}

			requestData.push(versionObject)
		})

		createFiles(requestData, _ => {
			closeCallback()
		}, progress => {
			// ZERO idea why it goes up and down...
			if (progress > this.state.uploadProgress) {
				this.setState({
					...this.state,
					uploadProgress: progress
				})
			}
		}, _ => {
			handleError("Oh no! An unknown error has occurred.")
			setLoading(false)

			this.setState({
				uploadProgress: 0
			})
		})

		return
	}

	getProjects = _ => {
		const {
			isGuest,
			allProjects,
			userData
		} = this.props

		if (!isGuest) {
			return allProjects
		} else {
			let invitedProjects = []

			forIn(allProjects, project => {
				const guestIdsArray = project.guests ? project.guests : project.guestIds

				if(guestIdsArray && guestIdsArray.indexOf(userData.id) !== -1){
					invitedProjects[project.id] = project
				}
			})

			return invitedProjects
		}
	}

	render() {
		const {
			allProjects,
			data,
			handleDismiss,
			closeCallback,
			allFiles,
			accountProjects
		} = this.props

		const {
			versions,
			uploadProgress,
			selectedVersionIndex,
			isOverQuota,
			validateResponsePinned,
		} = this.state

		let validateResponse = this.props.validateResponse ? this.props.validateResponse : null

		let modalClass = 'modal-upload borders'

		const currentVersion = this.getCurrentVersion()

		let isDupe = currentVersion.dupe

		let selectedProject = currentVersion.project_id ? allProjects[currentVersion.project_id] : null

		if (isDupe && !validateResponse) {
			validateResponse = {
				type: 'notice',
				message: 'This seems like an existing file!'
			}
		} else if (!validateResponse && data.chat) {
			validateResponse = {
				type: 'notice',
				message: `You may also want to select a project for ${versions.length == 1 ? 'this' : 'these'}.`
			}
		}

		return (
			<div>
				<div className={modalClass}>
					<div className="upload-progress">
						<span style={{ width: uploadProgress + '%' }}></span>
					</div>
					<div className={versions.length == 1 ? 'file-info-grid single' : 'file-info-grid'}>
						{
							versions.map((version, index) => {
								return (
									<button 
										onClick={_ => { this.selectVersion(index) }} 
										key={index} 
										className={selectedVersionIndex == index ? 'selected' : null}
									>
										{version.dupe ?
											<span className="dupe-alert">
												<Icon name="fe-flag" />
											</span>
											: null
										}
										{ this.getPreviewData(version) }
										{versions.length > 1 &&
											<span className="version-title">
												{version.title}
											</span>
										}
									</button>
								)

							})
						}
					</div>
					<div className="file-info-aside">
						<ValidateResponse 
							dismissCallback={handleDismiss} 
							response={validateResponse} 
							pinned={validateResponsePinned}
						/>
						<InputStandard
							outlineOnFocus={true}
							ref="titleInputRef"
							callback={null}
							value={currentVersion.title}
							onChange={e => { this.handleChange(e.target.value, 'title') }}
							placeholder="Title (optional)"
						/>
						{this.isUploadingToChat ?
							<DropdownMenu
								allowNone={true}
								label="Project"
								allItemEntities={this.getProjects()}
								parentType="project"
								parentKey="project_id"
								selectableItems={accountProjects.map(project => {
									return project.id
								})}
								selectedItemId={currentVersion.project_id ? currentVersion.project_id : null}
								handleChange={this.handleChange} />
							: null}
						{
							(currentVersion.project_id && !this.forceNewVersion) ?
								<div>
									<ul className="radio-list">
										<li>
											<label>
												<input
													type="radio"
													name="is_new"
													value={1}
													onChange={e => { this.handleChange(parseInt(e.target.value), 'is_new') }}
													checked={currentVersion.is_new == true} 
												/>
												<span>
													This is a <strong>new file</strong>.
												</span>
											</label>
										</li>
										<li>
											<label>
												<input
													type="radio"
													name="is_new"
													value={0}
													onChange={e => { this.handleChange(parseInt(e.target.value), 'is_new') }}
													checked={currentVersion.is_new == false}
												/>
												<span>
													This is a new version of an <strong>existing file</strong>.
												</span>
											</label>
										</li>
									</ul>
									<div>
										<SmoothCollapse 
											allowOverflowWhenOpen={true} 
											expanded={currentVersion.is_new == false}
										>
											<DropdownMenu 
												label="File" 
												allItemEntities={allFiles} 
												parentType="file" 
												parentKey="file_id" 
												selectableItems={(selectedProject && selectedProject.files) ? selectedProject.files : []} 
												selectedItemId={currentVersion.file_id} 
												handleChange={(value, key) => { this.handleChange(value, key) }} 
											/>
										</SmoothCollapse>
									</div>
								</div>
								:
								null
						}
					</div>
				</div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Upload'} 
					icon={'check'} 
					disabled={isOverQuota}
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentAccount: state.account.currentAccount,
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
		currentProject: state.account.entities.projects[state.account.currentProjectId],
		currentProjectId: state.account.currentProjectId,
		allFiles: state.account.entities.files,
		allVersions: state.account.entities.versions,
		allProjects: state.account.entities.projects,
		isGuest: isCurrentUserGuest(state),
		accountProjects: getAccountProjects(state)
	}
}

const ModalInviteWithValidateResponse = withValidateResponse(ModalUpload)

export default connect(mapStateToProps, { 
	createFiles, 
	getFiles,
	getStorageQuota,
	openModal
})(ModalInviteWithValidateResponse);



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-upload.jsx